import { Card, HStack, Spinner, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";

export const LoadingHeaderBase: React.FC = () => {
  const { loadingStore } = useStores();

  if (!loadingStore.message) return null;

  return (
    <Card.Root
      p={3}
      fontSize="xs"
      fontWeight="semibold"
      bgColor="primary.100"
      position="absolute"
      top={20}
      left={"50%"}
      variant={"elevated"}
      transform={"translateX(-50%)"}
      zIndex={10}
    >
      <HStack>
        <Spinner color={"primary.500"} />
        <Text>{loadingStore.message}</Text>
      </HStack>
    </Card.Root>
  );
};

export const LoadingHeader = observer(LoadingHeaderBase);
